import { i18n } from '../../../../../../shared/helpers/i18n';
import { safeDrawMedia } from '../draw-helpers';
import { getImage } from '../draw-images';
import {
    CONFERENCE_FONT,
    CONFERENCE_START_Y,
    getColors,
    LOGO_X,
    LOGO_Y,
    PICTURE_X,
    PICTURE_Y,
    TEXT_FONT,
    TEXT_LINE_HEIGHT,
    TEXT_START_Y,
    TITLE_FONT,
    TITLE_LINE_HEIGHT,
    TITLE_START_Y,
} from './constants';

interface DrawAloneScreenParams {
    meetingName?: string;
    callNumber: string;
}

export function drawAloneScreen(
    ctx: CanvasRenderingContext2D,
    { meetingName, callNumber }: DrawAloneScreenParams
): void {
    ctx.save();
    ctx.fillStyle = getColors().background;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    const logoFullRu = getImage('logoFullRu');
    const aloneScreenPicture = getImage('aloneScreenPicture');

    if (logoFullRu) {
        safeDrawMedia(ctx, { x: LOGO_X, y: LOGO_Y, width: logoFullRu.width, height: logoFullRu.height }, logoFullRu, {
            mode: 'contain',
            verticalAlign: 'center',
            horizontalAlign: 'center',
        });
    }

    if (aloneScreenPicture) {
        safeDrawMedia(
            ctx,
            {
                x: PICTURE_X,
                y: PICTURE_Y,
                width: aloneScreenPicture.width,
                height: aloneScreenPicture.height,
            },
            aloneScreenPicture,
            { mode: 'contain', verticalAlign: 'center', horizontalAlign: 'center' }
        );
    }

    ctx.fillStyle = getColors().title;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = TITLE_FONT;
    [i18n('room-agent', 'alone-screen-title-first-line'), i18n('room-agent', 'alone-screen-title-second-line')].forEach(
        (line, index) => {
            const y = TITLE_START_Y + index * TITLE_LINE_HEIGHT;
            ctx.fillText(line, ctx.canvas.width / 2, y);
        }
    );

    ctx.fillStyle = getColors().text;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = TEXT_FONT;
    [i18n('room-agent', 'alone-screen-text-first-line'), i18n('room-agent', 'alone-screen-text-second-line')].forEach(
        (line, index) => {
            const y = TEXT_START_Y + index * TEXT_LINE_HEIGHT;
            ctx.fillText(line, ctx.canvas.width / 2, y);
        }
    );

    ctx.fillStyle = getColors().conference;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = CONFERENCE_FONT;
    const textWithNameOrId = meetingName || `${i18n('conferences-history', 'conf-number')} ${callNumber}`;
    ctx.fillText(textWithNameOrId, ctx.canvas.width / 2, CONFERENCE_START_Y);

    ctx.restore();
}
